<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>汽车列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 卡片 -->
        <el-card class="box-card" style="margin-top:20px">
            <!-- 搜索  新增-->
            <el-form
                    :inline="true"
                    :model="searchForm"
                    :rules="searchRules"
                    ref="searchForRef"
                    label-width="80px"
                    autocomplete="on"
                    size="mini"
            >
                <el-row :gutter="24">
                    <el-col :span="24">
                        <el-form-item label="标题">
                            <el-input v-model="searchForm.title" clearable type="text"></el-input>
                        </el-form-item>
                        <el-form-item label="车系">
                            <el-cascader v-model="searchForm.style_ids"
                                         style="width: 100%" ref="cascaderCarStyle" @change="getval($event)"
                                         :props="{ value: 'id',label: 'name',children: 'children',checkStrictly: true}" :options="carStyleMenus" clearable></el-cascader>
                        </el-form-item>
                        <el-form-item label="年份">
                            <el-select
                                    v-model="searchForm.year_id"
                                    filterable
                                    clearable
                                    default-first-option
                                    placeholder="请选择年份">
                                <el-option
                                        v-for="item in carYearList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="success"  @click="searchSubmit()">搜索</el-button>
                            <el-button type="primary" @click="goAdd()">
                                <i class="el-icon-plus" ></i>新增
                            </el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <!-- 表格 -->
            <el-table
                    ref="multipleTable"
                    :data="tableLoadData"
                    stripe
                    border
                    size="mini"
            >
                <el-table-column
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>
                <el-table-column
                        label="标题"
                        width="120"
                        prop="title"
                        :show-overflow-tooltip='true'
                >
                </el-table-column>
                <el-table-column
                        label="车系"
                        width="200"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
                        {{scope.row.style&&scope.row.style.parent?scope.row.style.parent.name:''}}
                        {{scope.row.style?scope.row.style.name:''}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="年份"
                        width="160"
                >
                    <template slot-scope="scope">
                        {{scope.row.year?scope.row.year.name:''}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="孔距"
                        width="100"
                >
                    <template slot-scope="scope">
                        {{scope.row.pitch?scope.row.pitch.name:''}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="中心孔"
                        width="100"
                >
                    <template slot-scope="scope">
                        {{scope.row.center_bore}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="ET"
                        width="100"
                >
                    <template slot-scope="scope">
                        {{scope.row.et}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="原车尺寸"
                        width="120"
                >
                    <template slot-scope="scope">
                        {{scope.row.dimensions}}
                    </template>
                </el-table-column>
                <el-table-column
                        width="80"
                        label="是否检测"
                >
                    <template slot-scope="scope">
                        {{scope.row.detections?'是':''}}
                    </template>
                </el-table-column>
                <el-table-column
                        width="80"
                        label="推荐"
                >
                    <template slot-scope="scope">
                        {{scope.row.is_recommend==1?'是':""}}
                    </template>
                </el-table-column>
                <el-table-column
                        width="80"
                        label="排序"
                >
                    <template slot-scope="scope">
                        {{scope.row.sort}}
                    </template>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="220">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.file_url" @click="detectWheels(scope.row)"  type="text" size="mini">检测轮毂</el-button>
                        <el-button @click="goEdit(scope.row)"  type="text" size="mini">编辑</el-button>
                        <el-button @click="relationHub(scope.row)"  type="text" size="mini">关联轮毂</el-button>
                        <el-button @click="handelDel(scope.row)" style="color:#ff0000"  type="text" size="mini">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="block" style="margin-top:10px">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNum"
                        :page-sizes="[10, 20, 30, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </el-card>

        <!-- 轮毂关联抽屉（新增表单功能） -->
        <el-drawer
                size="50%"
                title="轮毂关联"
                :visible.sync="drawerHub"
                :with-header="true">
            <!-- 新增：轮毂关联表单 -->
            <div style="margin: 20px">
            <el-form
                    :model="hubForm"
                    ref="hubFormRef"
                    label-width="80px"
                    size="mini"
            >
                <el-row :gutter="20">
                   <el-col :span="20">
  <el-form-item label="轮毂" prop="hub_id" required>
    <el-input 
      v-model="hubForm.hub_name" 
      @click.native="openHubSelectDialog" 
      clearable 
      type="text"
      placeholder="请点击选择多个轮毂">
      <span slot="suffix" style="color: #ff0000">...</span>
    </el-input>
  </el-form-item>
</el-col>
</el-row>
 <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="分类" prop="category" required>
                            <el-select
                                    v-model="hubForm.category"
                                    placeholder="请选择分类"
                                    clearable
                            >
                                <el-option
                                        v-for="item in categoryOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item>
                            <el-button
                                    type="success"
                                    size="mini"
                                    @click="saveHubRelation"
                            >保存</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            </div>
            <!-- 轮毂列表表格（支持行点击选择） -->
            <el-table
                    style="margin-top: 20px;"
                    ref="hubTable"
                    :data="hubList"
                    size="mini"
                    stripe
                    border
                    @row-click="handleHubRowClick"
                    :row-class-name="({row}) => row.id === hubForm.hub_id ? 'selected-row' : ''"
            >
      
                <el-table-column label="序号" width="50">
        <template #default="scope">
          {{ (pageNum1 - 1) * pageSize1 + scope.$index + 1 }}
        </template>
      </el-table-column>
                <el-table-column
                        label="图片"
                        width="150"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
                        <el-image
                                style="width: 50px; height: 50px"
                                :src="scope.row.goods.goods_img"
                                :preview-src-list="[scope.row.goods.goods_img]"
                        ></el-image>
                    </template>
                </el-table-column>
                <el-table-column
                        label="名称"
                        width="150"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.goods.goods_name}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="分类"
                        width="150"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.cate_id==1?'原装款':'改装款'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="操作"
                        width="100">
                    <template slot-scope="scope">
                        <el-button @click="delHub(scope.row)"  type="text" size="mini">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="block" style="margin-top:10px">
                <el-pagination
                        background
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :current-page="pageNum1"
                        :page-sizes="[10, 20, 30, 100]"
                        :page-size="pageSize1"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total1">
                </el-pagination>
            </div>
        </el-drawer>

        <!-- 轮毂选择弹窗（可选） -->
        <el-dialog
                title="选择轮毂"
                :visible.sync="hubSelectDialog"
                width="60%"
                append-to-body
        >
            <el-table
                    ref="selectHubTable"
                    :data="hubList"
                    size="mini"
                    stripe
                    border
                    @row-click="confirmHubSelect"
                    row-key="id"
                    :selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column
                        label="图片"
                        width="150"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
                        <el-image
                                style="width: 50px; height: 50px"
                                :src="scope.row.goods.goods_img"
                                :preview-src-list="[scope.row.goods.goods_img]"
                        ></el-image>
                    </template>
                </el-table-column>
                <el-table-column
                        label="名称"
                        width="150"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.goods.goods_name}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="block" style="margin-top:10px">
                <el-pagination
                        background
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :current-page="pageNum1"
                        :page-sizes="[10, 20, 30, 100]"
                        :page-size="pageSize1"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total1">
                </el-pagination>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="hubSelectDialog = false">取消</el-button>
                <el-button type="primary" @click="confirmHubSelect">确定</el-button>
            </div>
        </el-dialog>

        <!-- 处理中弹窗 -->
        <el-dialog
                :visible.sync="processing"
                :show-close="false"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                width="30%"
        >
            <div class="loading-dialog">
                <el-progress
                        type="circle"
                        :percentage="progress"
                        :status="progress === 100 ? 'success' : undefined"
                />
                <div class="loading-text">
                    <p>{{ loadingText }}</p>
                    <p v-if="progress > 0">{{ progress }}%</p>
                </div>
            </div>
        </el-dialog>

        <eHubList
                :formData="formData1"
                :visible.sync="visible1"
                :title="title1"
                v-on:eventChoose="eChooseHub"
                :closeForm="closeForm1"
        />
    </div>
</template>

<script>
    import eHubList from "../common/eHubMultiList";
    import axios from 'axios'
    // API配置
    const API_BASE_URL = 'https://jm.shuangma88.com'; // 根据实际情况修改

    // 创建axios实例
    const http = axios.create({
        baseURL: API_BASE_URL,
        timeout: 30000,
        headers: {
            'Content-Type': 'application/json'
        }
    });

    // 请求拦截器
    http.interceptors.request.use(
        (config) => {
            // 可以在这里添加token等认证信息
            // const token = localStorage.getItem('token');
            // if (token) {
            //   config.headers.Authorization = `Bearer ${token}`;
            // }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    // 响应拦截器
    http.interceptors.response.use(
        (response) => {
            return response.data;
        },
        (error) => {
            const errorMsg = error.response?.data?.error || error.message || '网络请求失败';
            // ElementUI.Message.error(errorMsg);
            console.log(errorMsg)
            return Promise.reject(error);
        }
    );

    import moment from 'moment'     //日期时间转换
    export default {
        name: "carList",
        components: {eHubList},
        props: {},
        data() {
            return {
                selectedHubList: [], // 多选轮毂数组
                formData:{},
                title: '',
                visible:false,

                formData1:{},
                title1: '',
                visible1:false,

                api: http,
                openCar:false,
                // 处理相关
                confidence: 0.4,
                processing: false,
                progress: 0,
                loadingText: '处理中，请稍候...',

                carStyleMenus:[],
                pitch_id:'',
                drawerHub:false,
                hubList:[],
                total1:0,
                pageNum1:1,
                pageSize1:20,
                // 新增：轮毂选择弹窗控制
                hubSelectDialog: false,
                // 新增：选中的轮毂（弹窗用）
                selectedHubRows: [],
                // 新增：轮毂关联表单数据
                hubForm: {
                    hub_id: '',    // 选中轮毂ID
                    hub_name: '',  // 选中轮毂名称（显示用）
                    category: ''   // 分类：original(原装)、recommend(推荐款)
                },
                // 新增：分类选项
                categoryOptions: [
                    { label: '原装款', value: '1' },
                    { label: '改装款', value: '2' }
                ],
                // 新增：当前关联的汽车ID
                currentCarId: '',


                // 搜索
                searchForm: {
                    title: "",
                    style_ids:[],
                    style_id:'',
                    year_id:''
                },
                carYearList:[],
                searchRules: {
                    name: [
                        { required: true, message: "请输入名称", trigger: "blur" }
                    ],
                },
                // 数据
                tableLoadData: [],
                pageNum:1,// 当前页码
                pageSize:10,// 每页大小
                total:0,//总条目数

                showType: '',
                roleList: [],
                rules: {
                    name: [
                        { required: true, message: '请输入名称', trigger: 'blur' },
                        {
                            min: 3,
                            max: 15,
                            message: "长度在 3 到 15 个字符",
                            trigger: "blur",
                        }
                    ],
                },
                dialogFormVisible: false,
                form: {
                    name: '',
                },
            };
        },
        created() {
            this.DataList()
            this.getCarStyleMenus();
            this.getCarYeaList();
        },
        mounted() {},
        filters: {
            //时间格式化
            dateFormat(add_time) {
                if (add_time == undefined) {
                    return "";
                }
                return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
            },
        },
        methods: {

            // 检测轮毂
            async detectWheels(item) {
                this.processing = true;
                this.progress = 30;
                this.loadingText = '正在检测轮毂...';

                try {
                    const formData = new FormData();
                    formData.append('car_url', item.file_url);
                    // 添加置信度
                    formData.append('conf', this.confidence.toString());

                    this.progress = 60;
                    const startTime = Date.now();

                    // 调用API
                    const response = await this.api.post('/api/detect', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });

                    this.processingTime = Date.now() - startTime;
                    this.detectionResult = response;
                    this.progress = 90;

                    console.log('检测结果response',response)
                    if(response&&response.detections){
                        let param={
                            access_token:sessionStorage.getItem('token'),
                            company_id:sessionStorage.getItem('company_id'),
                            id:item.id,
                            detections:JSON.stringify(response.detections)
                        };

                        this.$axios.carinfoUpdateDetections(param).then(res=>{
                            if(res.code==200){
                                this.total=0;
                                this.tableLoadData=[];
                                this.pageNum=1;
                                this.DataList()
                            }
                            console.log(res)
                        });
                    }

                    this.progress = 100;
                    this.$message.success('轮毂检测完成!');

                    setTimeout(() => {
                        this.processing = false;
                        this.progress = 0;
                    }, 1000);

                } catch (error) {
                    this.processing = false;
                    this.progress = 0;
                    console.error('检测轮毂失败:', error);
                    this.$message.error('检测轮毂失败: ' + (error.response?.data?.error || error.message || '未知错误'));
                }
            },
            getCarStyleMenus(){
                let _this = this;
                let params={
                    access_token:sessionStorage.getItem('token'),
                    company_id:sessionStorage.getItem('company_id'),
                };
                this.$axios.findCarStyleTree(params).then((res)=>{
                    if(res.code == 200) {
                        _this.carStyleMenus=res.data;
                    }
                });
            },
            getCarYeaList(){
                let _this = this;
                let params={
                    access_token:sessionStorage.getItem('token'),
                    company_id:sessionStorage.getItem('company_id'),
                };
                this.$axios. findCarYearList(params).then((res)=>{
                    if(res.code == 200) {
                        _this.carYearList=res.data;
                    }
                });
            },
            getval() {
                let _this = this;
                const obj = this.$refs['cascaderCarStyle'].getCheckedNodes();
                console.log('obj',obj)
                if(obj.length>0){
                    _this.searchForm.style_id = obj[0].data.id;
                }else{
                    _this.searchForm.style_id="";
                }
            },
            // 关联轮毂（修改：记录当前汽车ID，重置表单）
            relationHub(row){
                this.drawerHub=true;
                this.pitch_id=row.pitch_id;
                this.currentCarId = row.id; // 保存当前要关联的汽车ID
                this.resetHubForm(); // 打开抽屉时重置表单
                this.getHubList();
            },
            closeForm1(){
                this.title1="";
                // this.addForm.proxy_id=this.formData.id;
                this.visible1=false;
            },
            eChooseHub(list){
               console.log('多选轮毂列表：', list)
  
  // 保存选中的数组
  this.selectedHubList = list

  // 把多个轮毂名称拼接显示
  let names = list.map(item => item.goods_name).join('，')
  this.hubForm.hub_name = names // 显示到输入框
  this.hubForm.hub_id = list.map(item => item.goods_id).join(',') // 用逗号分隔ID

            },
            delHub(e) {
                console.log(e);
                this.$confirm('此操作将删除关联轮毂, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const param = {
                        operator_id: sessionStorage.getItem('user_id'),
                        company_id:sessionStorage.getItem('company_id'),
                        access_token:sessionStorage.getItem('token'),
                        id: e.id,
                    }
                    this.$axios.delCarGoods(param).then(res=>{
                        if(res.code == 200){
                            this.$message.success(res.msg);
                            this.getHubList();
                        }else{
                            this.$message.error(res.msg);
                        }
                    }).catch(error=>{
                        console.log(error);
                    })
                }).catch((err) => {
                    // 点击取消:不删除了
                    this.$message({
                        type: 'info',
                        message: '已取消删除'+err
                    });
                    this.DataList()
                });
                this.teamDialog = false
            },
            getHubList(){
                const param = {
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token'),
                    pageNum:this.pageNum1,
                    pageSize: this.pageSize1,
                    car_id:this.currentCarId
                }
                this.$axios.findCarGoodsListP(param).then(res=>{
                    if(res.code == 200){
                        this.hubList = res.data.data
                        this.total1 = res.data.total
                    }
                }).catch(error=>{
                    console.log(error);
                })
            },
            // 新增：打开轮毂选择弹窗
            openHubSelectDialog() {

                this.title1="选择轮毂";
               // this.formData.pid=sessionStorage.getItem('proxy_id')
                this.visible1=true;
                //
                // this.hubSelectDialog = true;
                // this.getHubList(); // 刷新轮毂列表
            },
            // 新增：弹窗中选择轮毂（多选事件）
            handleSelectionChange(val) {
                this.selectedHubRows = val;
            },
            // 新增：确认选择轮毂（弹窗确定）
            confirmHubSelect(row) {
                // 如果是行点击，直接选中该行；否则取多选的第一条
                const selectRow = row || (this.selectedHubRows.length > 0 ? this.selectedHubRows[0] : null);
                if (!selectRow) {
                    this.$message.warning('请选择一个轮毂');
                    return;
                }
                this.hubForm.hub_id = selectRow.id;
                this.hubForm.hub_name = selectRow.goods_name;
                this.hubSelectDialog = false;
            },
            // 新增：抽屉表格行点击选择轮毂
            handleHubRowClick(row) {
                this.hubForm.hub_id = row.id;
                this.hubForm.hub_name = row.goods_name;
            },
            // 新增：重置轮毂表单
           resetHubForm() {
  this.hubForm = {
    hub_id: '',
    hub_name: '',
    category: ''
  }
  this.selectedHubList = [] // 清空多选
  if (this.$refs.hubFormRef) {
    this.$refs.hubFormRef.resetFields()
  }
},
            // 新增：保存轮毂关联和分类
            // 批量保存轮毂关联
saveHubRelation() {
  if (this.selectedHubList.length === 0) {
    this.$message.warning('请选择轮毂')
    return
  }
  if (!this.hubForm.category) {
    this.$message.warning('请选择分类')
    return
  }
  if (!this.currentCarId) {
    this.$message.warning('关联的汽车信息丢失，请重新操作')
    return
  }

  // 批量保存
  let promiseArr = {
      access_token: sessionStorage.getItem('token'),
      company_id: sessionStorage.getItem('company_id'),
      car_id: this.currentCarId,
      goods_id:this.hubForm.hub_id,
      cate_id: this.hubForm.category
    }

  // 执行批量保存
   this.$axios.carGoodsSaveBatch(promiseArr).then(res => {
    if(res.code==200){
      this.$message.success('批量保存成功！')
    this.drawerHub = false
    this.resetHubForm()
    this.getHubList() // 刷新关联列表
    }
   
  }).catch(err => {
    this.$message.error('保存失败：' + err.message)
  })
},
            closeForm(){
                this.title="";
                this.visible=false;
            },
            goEdit(row){
                this.$router.push({path:'/carForm',query:{id:row.id}})
            },
            goAdd(){
                this.$router.push('/carForm')
            },
            indexMethod(index) {
                return (this.pageNum - 1) * this.pageSize + index + 1
            },
            DataList(){
                const param = {
                    access_token:sessionStorage.getItem('token'),
                    company_id:sessionStorage.getItem('company_id'),
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,

                }

                if(this.searchForm.title){
                    param.keywords=this.searchForm.title;
                }
                console.log(this.searchForm.style_ids)
                if(this.searchForm.style_id){
                    param.style_id=this.searchForm.style_id;
                }
                if(this.searchForm.year_id){
                    param.year_id=this.searchForm.year_id;
                }
                this.$axios.findCarListP(param).then(res=>{
                    if(res.code == 200){
                        this.tableLoadData = res.data.data
                        this.total = res.data.total
                    }
                }).catch(error=>{
                    console.log(error);
                })
            },
            // 设置每页条数
            handleSizeChange(newSize) {
                this.pageSize = newSize
                this.DataList()
            },
            // 分页跳转
            handleCurrentChange(newPage) {
                this.pageNum = newPage
                this.DataList()
            },
            handleSizeChange1(newSize) {
                this.pageSize1 = newSize
                this.getHubList()
            },
            // 分页跳转
            handleCurrentChange1(newPage) {
                this.pageNum1 = newPage
                this.getHubList()
            },
            departData(){
                const param = {
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token'),
                }
                this.$axios.findTree(param).then(res=>{
                    if(res.code == 200){
                        this.rightslist = res.data.data
                    }
                }).catch(error=>{
                    console.log(error);
                })
            },
            // 新增
            addData() {
                this.$router.push('/newsForm')
            },
            handelEdit(index) {
                this.id = index.data.row.id
                this.title = '编辑'
                this.form = {
                    name: this.name,
                }
                this.dialogFormVisible = true
                this.form = JSON.parse(JSON.stringify(index.data.row))
            },
            reset_dialogForm(formName) {
                this.dialogFormVisible = false
                this.$nextTick(() => {
                    this.$refs[formName].resetFields()
                })
            },
            searchSubmit() {
                this.total=0;
                this.pageNum=1;
                this.tableLoadData=[];
                this.DataList();
            },
            handelDel(row) {
  this.$confirm('此操作将删除记录,不能恢复, 是否继续?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    // 这里加一层判断，防止 e 或 row 不存在导致报错
    if (!row || !row.id) {
      this.$message.error('删除数据异常，未获取到有效ID');
      return;
    }

    const param = {
      operator_id: sessionStorage.getItem('user_id'),
      company_id: sessionStorage.getItem('company_id'),
      access_token: sessionStorage.getItem('token'),
      id: row.id,
    };

    this.$axios.carDel(param).then(res => {
      if (res.code == 200) {
        this.$message.success(res.msg);
        this.DataList(); // 刷新列表
      } else {
        this.$message.error(res.msg || '删除失败');
      }
    }).catch(error => {
      console.error('删除接口报错：', error);
      this.$message.error('删除请求失败，请检查网络或接口');
    });
  }).catch(() => {
    this.$message({
      type: 'info',
      message: '已取消删除'
    });
    });

  // 把这行注释/删掉！！！这是最常见报错原因
  // this.teamDialog = false;
            },
        },
    };
</script>
<style>
    /* 选中行高亮样式 */
    .selected-row {
        background-color: #e6f7ff !important;
    }
    /* 加载弹窗样式优化 */
    .loading-dialog {
        text-align: center;
        padding: 20px 0;
    }
    .loading-text {
        margin-top: 15px;
        font-size: 14px;
        color: #666;
    }
</style>
